import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MODELS_SOURCES } from '../../constants';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const GdaScoreModels: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const sourcesText = MODELS_SOURCES.join(', ');
  
  const introMath = createMathML(`
    <mrow>
      <mtext>The set M of MODELS sources is defined as:</mtext>
    </mrow>
  `, 'inline');

  const setDefinition = createMathML(`
    <mrow>
      <mi>M</mi>
      <mo>=</mo>
      <mo stretchy="true" form="prefix">&#123;</mo>
      <mrow>
        <mi>${sourcesText}</mi>
      </mrow>
      <mo stretchy="true" form="postfix">&#125;</mo>
    </mrow>
  `);

  const subsetDefinition = createMathML(`
    <mrow>
      <mtext>Given a subset</mtext>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mrow>
          <mi mathvariant="italic">M</mi>
        </mrow>
      </msub>
      <mo>,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>S</mi>
        <mrow>
          <mi mathvariant="italic">M</mi>
        </mrow>
      </msub>
      <mspace width="0.222em" />
      <mo>⊆</mo>
      <mspace width="0.222em" />
      <mo>M,</mo>
      <mspace width="0.222em" />
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">M</mi>
        </mrow>
      </msub>
      <mspace width="0.222em" />
      <mtext>is defined as:</mtext>
    </mrow>
  `, 'inline');

  const weightDefinition = createMathML(`
    <mrow>
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">M</mi>
        </mrow>
      </msub>
      <mo>=</mo>
      <mrow>
        <mo stretchy="true" form="prefix">&#123;</mo>
        <mtable>
          <mtr>
            <mtd><mn>0.2</mn></mtd>
            <mtd>
              <mi>if</mi>
              <mspace width="0.222em" />
              <msub>
                <mi>|S</mi>
                <mrow>
                  <mi mathvariant="italic">M</mi>
                </mrow>
              </msub>
              <mi>|</mi>
              <mo>&gt;</mo>
              <mn>0</mn>
              <mspace width="0.222em" />
            </mtd>
          </mtr>
          <mtr>
            <mtd><mn>0</mn></mtd>
            <mtd>
              <mi>if</mi>
              <mspace width="0.222em" />
              <msub>
                <mi>|S</mi>
                <mrow>
                  <mi mathvariant="italic">M</mi>
                </mrow>
              </msub>
              <mi>|</mi>
              <mo>=</mo>
              <mn>0</mn>
              <mspace width="0.222em" />
            </mtd>
          </mtr>
        </mtable>
      </mrow>
    </mrow>
  `);

  return (
    <div className={className} style={style}>
      <MathMLRenderer mathML={introMath} />
      <MathMLRenderer mathML={setDefinition} />
      <MathMLRenderer mathML={subsetDefinition} className="pl-4" />
      <MathMLRenderer mathML={weightDefinition} />
    </div>
  );
};